module.exports = __webpack_public_path__ + "static/img/1_0050.4934930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0050.jpg
// module id = CisI
// module chunks = 0